import Home from "../Home";
import Mainpage from "../Mainpage";
import Login from "../Login/LoginPage";
import BillingSummaryReportPage from "../BillingSummaryReport/BillingSummaryReport";
import BillingDetailPage from "../BillingDetail/BillingDetail";
import specialofBilling from "../SpecialBilling/SpecialBillingPage";

export const Index = Home;
export const HomePage = Mainpage;
export const BillingSummaryReport = BillingSummaryReportPage;
export const BillingDetail = BillingDetailPage;
export const LoginPage = Login;
export const SpecialofBilling = specialofBilling;